var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import styled from 'styled-components';
import infoIcon from '../../assets/images/icons/common/icon-info.png';
import { TooltipContext } from '../../context/tooltip';
export default function InfoButton(_a) {
    var showTooltip = _a.showTooltip;
    var setTooltipProps = useContext(TooltipContext).setTooltipProps;
    return (_jsx(Container, { onMouseEnter: showTooltip, onMouseLeave: function () { return setTooltipProps(undefined); }, children: _jsx("img", { alt: "info", src: infoIcon }) }));
}
var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  border: ", ";\n  border-radius: 6px;\n  display: flex;\n  height: 12px;\n  flex-direction: row;\n  justify-content: center;\n  margin-left: 4px;\n  width: 12px;\n\n  & > img {\n    height: 100%;\n    width: 100%;\n  }\n"], ["\n  align-items: center;\n  border: ", ";\n  border-radius: 6px;\n  display: flex;\n  height: 12px;\n  flex-direction: row;\n  justify-content: center;\n  margin-left: 4px;\n  width: 12px;\n\n  & > img {\n    height: 100%;\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "solid 1px ".concat(theme.palette.text);
});
var templateObject_1;
